import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";

const data = [
  {
    key: "1",
    incidentID: "C001",
    caseStatus: "Open",
    associatedDocuments: "Case Report.pdf, Briefing.doc",
    deadlines: "2024-12-15 (Hearing Date)",
  },
  {
    key: "2",
    incidentID: "C001",
    caseStatus: "Closed",
    associatedDocuments: "Motion Filed.doc",
    deadlines: "N/A",
  },
  {
    key: "3",
    incidentID: "C001",
    caseStatus: "Pending",
    associatedDocuments: "Final Decision.pdf",
    deadlines: "2024-11-20 (Evidence Deadline)",
  },
];

const LegalTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);

  const onDelClick = () => {
    setIsdelModalOpen(true);
  };

  const columns = [
    {
      title: t("dashboard.legalProceedings.incidentID"),
      dataIndex: "incidentID",
      key: "incidentID",
      render: (text) => <p className="text-darkGrey small font-poppins">{text}</p>,
    },
    {
      title: t("dashboard.legalProceedings.caseStatus"),
      dataIndex: "caseStatus",
      key: "caseStatus",
      render: (status) => (
        <Tag
          color={status === "Open" ? "green" : status === "Closed" ? "red" : "orange"}
          className="rounded-[54px] border-none px-3 py-1 text-white font-medium e-small"
        >
          {status}
        </Tag>
      ),
    },
    {
      title: t("dashboard.legalProceedings.associatedDocuments"),
      dataIndex: "associatedDocuments",
      key: "associatedDocuments",
      render: (documents) => <p className="text-darkGrey small font-poppins">{documents}</p>,
    },
    {
      title: t("dashboard.legalProceedings.deadlines"),
      dataIndex: "deadlines",
      key: "deadlines",
      render: (date) => <p className="text-darkGrey small font-poppins">{date}</p>,
    },
    {
      title: t("dashboard.legalProceedings.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => {
              navigate("/legal/legal-proceedings-details");
            }}
          >
            {t("dashboard.legalProceedings.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      {" "}
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
    </>
  );
};

export default LegalTable;
